<template>
  <div>
    <el-card class="box-card" style="margin-top: 20px;">
      <el-row :span="24">
        <el-col :span="12">
          <el-button v-auth="'/examType/addExamType'" type="primary" @click="addFormVisible = true" icon="el-icon-plus">新增</el-button>
          <el-button v-auth="'/examType/deleteExamType'" type="danger" @click="batchDeleteExamType" icon="el-icon-minus">批量删除</el-button>
        </el-col>
      </el-row>
      <el-table
        ref="multipleTable"
        :data="page.rows"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%;"
        v-loading="Loading"
        border
        @selection-change="selectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="sort" width="80" label="排序" show-overflow-tooltip></el-table-column>
        <el-table-column prop="type" width="200" label="类型模式" show-overflow-tooltip></el-table-column>
        <el-table-column prop="name" label="类型名称" show-overflow-tooltip></el-table-column>
        <el-table-column prop label="操作" width="100" align="center">
          <template slot-scope="scope">
            <div class="operationGroup">
              <i
                v-auth="'/examType/editExamType'"
                class="iconfont iconbianji mainColor"
                title="编辑"
                @click="selection = scope.row.id, editFormVisible = true"
              ></i>
              <i
                v-auth="'/examType/deleteExamType'"
                class="iconfont iconshanchu mainColor"
                title="删除"
                @click="deleteExamType(scope.row)"
              ></i>
              <!-- <span @click="selection = scope.row.id, editFormVisible = true">编辑</span>
              <span @click="deleteExamType(scope.row)">删除</span>-->
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="!Loading"
        background
        :page-sizes="[10, 20, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        style="margin-top: 20px;text-align: right;"
        :total="page.total"
        :page-size="page.pageSize"
        :current-page="page.pageNumber"
        @size-change="sizeChange"
        @current-change="currentChange"
      ></el-pagination>
    </el-card>

    <el-dialog title="新增" :visible.sync="addFormVisible" width="400px" left>
      <el-form ref="addForm" :model="addForm" :label-width="formLabelWidth" :rules="addFormRules">
        <el-col :sm="24" :md="24" :lg="24">
          <el-form-item label="类型名称" prop="name">
            <el-input
              v-model="addForm.name"
              placeholder="请输入类型名称"
              auto-complete="off"
              maxlength="255"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="24" :lg="24">
          <el-form-item label="类型模式" prop="type">
            <el-select style="width:100%" clearable v-model="addForm.type" placeholder="请选择类型模式">
              <el-option
                v-for="item in typeList"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="24" :lg="24">
          <el-form-item label="排序" prop="sort">
            <el-input
              type="number"
              v-model="addForm.sort"
              placeholder="请输入排序"
              auto-complete="off"
              maxlength="255"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align:right">
        <el-button @click="addFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addExamType">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="编辑" :visible.sync="editFormVisible" width="400px" left>
      <el-form
        ref="editForm"
        :model="editForm"
        :label-width="formLabelWidth"
        :rules="editFormRules"
      >
        <el-col :sm="24" :md="24" :lg="24">
          <el-form-item label="类型名称" prop="name">
            <el-input
              v-model="editForm.name"
              placeholder="请输入类型名称"
              auto-complete="off"
              maxlength="255"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="24" :lg="24">
          <el-form-item label="类型模式" prop="type">
            <el-select style="width:100%" clearable v-model="editForm.type" placeholder="请选择类型模式">
              <el-option
                v-for="item in typeList"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="24" :lg="24">
          <el-form-item label="排序" prop="sort">
            <el-input
              v-model="editForm.sort"
              placeholder="请输入排序"
              auto-complete="off"
              maxlength="255"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="editFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateExamType">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="导入" :visible.sync="importFormVisible" width="80%" left>
      <el-upload
        class="upload-demo"
        :action="fileAction"
        :on-success="handleSuccess"
        :headers="reqData"
        :file-list="fileList"
      >
        <el-button size="small" type="primary" icon="el-icon-upload">点击上传</el-button>
        <div slot="tip" class="el-upload__tip">只能上传xls、xlsx文件，且不超过1024kb</div>
      </el-upload>
      <el-table
        ref="multipleTable"
        :data="importForm.rows"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%;"
        height="520"
        border
        @selection-change="selectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="name" label></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer" style="text-align: left">
        <el-button type="primary" @click="importData" icon="el-icon-document">导入数据</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: ""
      },
      addFormVisible: false,
      editFormVisible: false,
      importFormVisible: false,
      Loading: false,
      searchForm: {},
      addForm: {
        name: "",
        sort: "",
        type: ""
      },
      typeList: [
        { name: "考试", value: "考试" },
        { name: "章节", value: "章节" }
      ],
      addFormRules: {
        name: [
          {
            required: true,
            message: "请输入类型名称",
            trigger: "blur"
          },
          {
            min: 1,
            max: 255,
            message: "长度在1到255个字"
          }
        ],
        type: [
          {
            required: true,
            message: "请选择类型模式",
            trigger: "blur"
          }
        ],
        sort: [
          {
            pattern: /^[1-9]\d*$/,
            message: "排序格式不正确"
          }
        ]
      },
      editForm: {
        name: "",
        sort: "",
        type: ""
      },
      editFormRules: {
        name: [
          {
            required: true,
            message: "请输入类型名称",
            trigger: "blur"
          },
          {
            min: 1,
            max: 255,
            message: "长度在1到255个字"
          }
        ],
        type: [
          {
            required: true,
            message: "请选择类型模式",
            trigger: "blur"
          }
        ],
        sort: [
          {
            pattern: /^[1-9]\d*$/,
            message: "排序格式不正确"
          }
        ]
      },
      importForm: {},
      formLabelWidth: "80px",
      selection: "",
      multipleSelection: "",
      ids: [],
      fileAction: `${process.env.BASE_URL}/examType/upload`,
      fileList: [],
      loading: false
    };
  },
  methods: {
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.pageList();
    },
    currentChange(pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList();
    },
    selectionChange(val) {
      this.multipleSelection = val;
      val.map(e => this.ids.push({ id: e.id }));
    },
    getExamType() {
      this.api.examType
        .getExamType({
          id: this.selection
        })
        .then(result => {
          this.editForm = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    pageList() {
      this.Loading = true;
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.pageNumber = this.page.pageNumber;
      this.searchForm.sortName = this.page.sortName;
      this.searchForm.sortOrder = this.page.sortOrder;
      this.api.examType
        .pageList(this.searchForm)
        .then(result => {
          this.page.rows = result.data.records;
          this.Loading = false;
          this.page.total = result.data.total;
        })
        .catch(error => {
          console.log(error);
        });
    },
    addExamType() {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          this.api.examType
            .addExamType(this.addForm)
            .then(result => {
              this.addFormVisible = false;
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    updateExamType() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.api.examType
            .updateExamType(this.editForm)
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.editFormVisible = false;
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    deleteExamType(row) {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning"
      })
        .then(() => {
          this.api.examType
            .deleteExamType([
              {
                id: row.id
              }
            ])
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(() => {});
    },
    batchDeleteExamType() {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning"
      })
        .then(() => {
          this.api.examType
            .deleteExamType(this.ids)
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(() => {});
    },
    reset() {
      this.$refs.searchForm.resetFields();
      this.page = {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: ""
      };
      this.pageList();
    },
    handleSuccess(response, file, fileList, $event) {
      this.importForm = response.data;
    },
    exportExcel() {
      this.loading = true;
      this.api.examType
        .exportExcel(this.searchForm)
        .then(result => {
          location.href = result.data;
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    importData() {
      this.api.examType
        .importData(this.importForm.rows)
        .then(result => {
          this.$message({
            type: "success",
            message: result.message
          });
          this.pageList();
          this.importFormVisible = false;
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  computed: {
    reqData() {
      return this.$store.state.user;
    }
  },
  watch: {
    addFormVisible: function(newVal) {
      if (!newVal) {
        this.$refs.addForm.resetFields();
        this.pageList();
      } else {
      }
    },
    editFormVisible: function(newVal) {
      if (!newVal) {
        this.$refs.editForm.resetFields();
        this.pageList();
      } else {
        this.getExamType();
      }
    }
  },
  mounted() {
    this.pageList();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/examType/index.vue